import enGB from './en-GB';
import enUS from './en-US';

export default {
  'en-GB': enGB,
  'en-US': enUS,
};
